import type { IDropDownItem, ISellAssets } from 'BreetHelpers';
import type { MouseEvent } from 'react';

export type IFundingMethod = 'Crypto' | 'Bank';

export interface IFundRequestContext {
	selectedWallet?: IDropDownItem;
	selectWallet: (wallet?: IDropDownItem) => void;
	selectFundingMethod: (item: IDropDownItem) => (e: MouseEvent<HTMLButtonElement>) => void;
	fundingMethod: string;
}

export const sortTradeAssets = (a: ISellAssets, b: ISellAssets) => {
	if (a.name > b.name) return 1;
	if (a.name < b.name) return -1;
	return 0;
};

export const filterAssetItem = (item: ISellAssets) => item.wallet?.isVip && !item.wallet.isBusiness;

export const filterAssetItemSymbol = (symbol: string) => (item: ISellAssets) => item.symbol !== symbol;

export interface IAccountDetailsItem {
	label: string;
	value: string;
	loading?: boolean;
}
